import request from './base';

const api = {
    /**
     *
     * @param {string} account 用户名
     * @param {string} password 密码
     * @returns
     */
    login(account, password) {
        return request.post('/api/user/login', { account, password });
    },
    register(data) {
        return request.post('/api/user/register', data);
    },
    get_code(data) {
        return request.post('/api/sms/send', data);
    },
    enterpriseRegister(data) {
        return request.post('/api/Dake/enterpriseRegister', data);
    },
    confirmInfo(data) {
        return request.post('/api/Dake/isUser', data);
    },
    // 企业忘记密码
    forgetPassWord(data) {
        return request.post('/api/Dake/changePWD', data);
    },
    //个人忘记密码
    changePersonPWD(data) {
        return request.post('/api/Dake/changePersonPWD', data);
    }
};

export default api;
